var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "page_Container" } }, [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          {
            staticClass: "main-container flexClass",
            attrs: { id: "main-container" }
          },
          [
            _c("div", { staticClass: "boxWrapper" }, [
              _c("img", {
                staticClass: "box-img",
                attrs: {
                  src: require("../assets/img/notFound/sys-maintance@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "box-text" }, [_vm._v("系统维护中…")])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }